<template>
  <div class="full-container service">
    <apj-page-banner :options="options"></apj-page-banner>

    <div ref="row_1">
      <div class="setion service-list" style="margin-top: 70px">
        <div class="desc pi-flex-column-center">
          <div class="title page-title">{{ serviceDesc.title }}</div>
          <div class="text" style="max-width: 1300px;text-align:left;">
            <span style="padding: 20px 40px"> {{ serviceDesc.text }}</span>
          </div>
        </div>
        <div class="list" style="padding: 0 160px">
          <div
            class="wrapper"
            v-for="(lItem, index) in serviceTypes"
            :key="index"
            :class="{
              special: lItem.special,
            }"
          >
            <div
              class="item"
              :class="
                isMobile || show_obj.row_1
                  ? 'animate__animated animate__fadeInUp'
                  : 'hide'
              "
            >
              <i v-if="lItem.icon" class="iconfont" :class="lItem.icon"></i>
              <div class="info">
                <div class="title">{{ lItem.title }}</div>
                <div class="text">{{ lItem.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="service-type" ref="row_2" style="padding: 20px 0 20px">
      <div class="container">
        <div class="setion pi-align-center">
          <div class="desc pi-flex-column-center">
            <div class="title page-title">{{ techDesc.title }}</div>
            <div class="text" style="max-width: 1389px;text-align:left;">
              <span style="padding: 20px 40px" class="pi-text-center"> {{ techDesc.text }}</span>
            </div>
          </div>
          <div
            style="max-width: 1389px"
            class="tech-diagram"
            :class="
              isMobile || show_obj.row_2
                ? 'animate__animated animate__fadeInUp'
                : 'hide'
            "
          >
            <div class="diagram-row">
              <div class="title-box">
                <i class="iconfont" :class="techDesc.type[0].icon"></i>
                <span>{{ techDesc.type[0].title }}</span>
              </div>
              <div class="content-box">
                <div
                  class="industry-box"
                  v-for="(item, index) in techDesc.industry"
                  :key="'industry' + index"
                >
                  <i class="iconfont" :class="item.icon"></i>
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="diagram-row">
              <div class="title-box">
                <i class="iconfont" :class="techDesc.type[1].icon"></i>
                <span>{{ techDesc.type[1].title }}</span>
              </div>
              <div class="content-box" style="flex-direction: column">
                <div class="techType-box">
                  <div
                    v-for="(item, index) in techDesc.techType"
                    :key="'techType' + index"
                  >
                    <span>{{ item }}</span>
                    <span v-if="index != techDesc.techType.length - 1">|</span>
                  </div>
                </div>
                <el-image :src="techDesc.techIcon" fit="contain"></el-image>
              </div>
            </div>
            <div class="diagram-row">
              <div class="title-box">
                <i class="iconfont" :class="techDesc.type[2].icon"></i>
                <span>{{ techDesc.type[2].title }}</span>
              </div>
              <div class="content-box">
                <div
                  class="mode-box"
                  v-for="(item, index) in techDesc.mode"
                  :key="'mode' + index"
                >
                  <div class="mode-btn">{{ item.title }}</div>
                  <span>{{ item.desc }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="quality-assurance" ref="row_3">
      <div class="container">
        <div class="setion pi-align-center" style="padding-top: 60px">
          <div class="desc pi-flex-column-center">
            <div class="title page-title">{{ qaDesc.title }}</div>
            <div class="text" style="max-width: 1389px;text-align:left;">
              <span style="padding: 20px 40px" class="pi-text-center"> {{ qaDesc.text }}</span>
            </div>
          </div>
          <el-image
            :class="
              isMobile || show_obj.row_3
                ? 'animate__animated animate__fadeInUp'
                : 'hide'
            "
            :src="qaDesc.icon"
            style="max-width: 1276px; margin-bottom: 0"
            fit="contain"
          ></el-image>
        </div>
      </div>
    </div>
    <div class="quality-assurance" ref="row_4">
      <div class="container">
        <div class="setion" style="padding-bottom: 30px; padding-top: 30px">
          <div class="desc pi-flex-column-center">
            <div class="title page-title">{{ qcDesc.title }}</div>
            <div class="text" style="max-width: 1389px;text-align:left;">
              <span style="padding: 20px 40px" class="pi-text-center"> {{ qcDesc.text }}</span>
            </div>
          </div>
          <el-image
            :class="
              isMobile || show_obj.row_4
                ? 'animate__animated animate__fadeInUp'
                : 'hide'
            "
            :src="qcDesc.icon"
            style="max-width: 1054px; margin-top: 20px"
            fit="contain"
          ></el-image>
        </div>
      </div>
    </div>

    <div class="safe" style="margin-bottom: 30px">
      <div class="container">
        <div class="setion" style="padding-top: 0">
          <div class="desc">
            <div class="title page-title" style="padding-bottom: 20px">
              {{ safe.title }}
            </div>
          </div>
          <div class="items">
            <div
              class="item"
              v-for="(item, index) in safe.items"
              :key="'item' + index"
            >
              <div class="content">
                <el-image
                  class="icon"
                  :src="item.icon"
                  fit="contain"
                ></el-image>
                <div class="desc-content">
                  <div class="title">{{ item.title }}</div>
                  <div class="desc">{{ item.desc }}</div>
                  <ul class="texts">
                    <li
                      v-for="(sItem, sIndex) in item.texts"
                      :key="'text' + sIndex"
                    >
                      <span>{{ sItem }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <el-image
                v-if="item.img"
                class="img"
                :src="item.img"
                fit="contain"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <apj-page-contact></apj-page-contact> -->
  </div>
</template>

<script>
import { isMobile, scrollTop } from "@/utils";
import ApjPageContact from "@/components/apj-page-contact";
import ApjPageBanner from "@/components/apj-page-banner";
export default {
  name: "service",
  components: {
    ApjPageContact,
    ApjPageBanner,
  },
  data() {
    return {
      show: false,
      isMobile: isMobile(),
      offsetTop: {
        row_1: 0,
        row_2: 0,
        // row_2: 0,
        row_3: 0,
        row_4: 0,
        // row_5: 0,
      },
      show_obj: {
        row_1: false,
        row_2: true,
        row_4: false,
        row_3: false,
        // row_4: false,
        // row_5: false,
      },
      indTabIndex: 0,
      options: {
        banner: require("@/assets/site/banner_service.png"),
        title: "数字技术与能力沉淀释放，赋能客户价值链再造升级",
        text: "",
        // text: "通过创新性前沿技术革新业务模式、业务流程和工作方式",
      },
      // banner: require('@/assets/images/banner/service.jpg'),
      msg: "Welcome to Your Vue.js App",
      serviceDesc: {
        special: true,
        icon: "",
        title: "数字化服务项目",
        text:
          "APJ数字化服务以客户需求为基础,其业务包括行业信息化咨询、定制化软件开发、第三方软件测试、系统化技术支持、软件服务外包（ITO）、专业IT人才服务等，其服务覆盖软件全生命周期，涵盖开发流程中的各个阶段：需求分析、概要设计、详细设计、编码、单元测试、集成测试、系统测试、软件运维等。APJ提供专业的数字化服务，帮助客户明确人员需求,快速匹配资源，高效现场管理及人员再配置。我们的客户包括香港铁路有限有公司(MTR)、堡狮龙国际集团有限公司(bossini)、爱普生技术(深圳)有限公司(EPSON)、香港中华煤气有限公司(Towngas).香港八达通卡有限公司(Octopus)、溢达集团(ESQUEL)、香港空运货站有限公司(HSL)等",
      },
      techDesc: {
        special: true,
        icon: require("@/assets/site/service-tech.png"),
        title: "数字化服务能力",
        text:
          "APJ本着不断创新、不断进取的态度，聚焦前沿技术，保持始终能够驾驭新型技术、核心技术、众多应用技术的强大研发实力，并且提供灵活的服务模式，帮助客户加快业务变革，提高交付效率。APJ将持续在金融银行、生产制造、石油化工、轨道交通、公共事业、互联网教育等众多行业中深耕细作，积累经验，提升行业服务能力。",
        industry: [
          {
            name: "生产制造",
            icon: "iconshengchanzhizao",
          },
          {
            name: "教育行业",
            icon: "iconjiaoyu1",
          },
          {
            name: "医疗健康",
            icon: "iconyiliaohangye",
          },
          {
            name: "轨道交通",
            icon: "iconguidaojiaotong",
          },
          {
            name: "石油化工",
            icon: "iconshiyouhuagong",
          },
          {
            name: "金融行业",
            icon: "iconjinronghangye",
          },
          {
            name: "公共事业",
            icon: "icongonggongshiye",
          },
          {
            name: "零售业",
            icon: "iconlingshouye",
          },
        ],
        techType: [
          "大数据",
          "云计算",
          "人工智能",
          "物联网",
          "网络信息安全",
          "应用开发",
          "IoT技术",
          "工业互联网",
        ],
        techIcon: require("@/assets/site/tech-icon.png"),
        mode: [
          {
            title: "在岸开发",
            desc: "APJ根据客户需求，提供现场开发服务并对客户项目交付负责。",
          },
          {
            title: "离岸开发",
            desc: "APJ为境外客户建立离岸开发中心，对客户项目交付负责。",
          },
          {
            title: "驻场开发",
            desc: "APJ派遣专业人才给客户，协助客户按时按质完成项目。",
          },
        ],
        type: [
          {
            icon: "iconhangyejingyan",
            title: "丰富的行业经验",
          },
          {
            icon: "iconjiaofunengli",
            title: "前沿的技术能力",
          },
          {
            icon: "iconjiaofumoshi",
            title: "灵活的服务模式",
          },
        ],
      },
      qaDesc: {
        special: true,
        icon: require("@/assets/site/service-QA.png"),
        title: "软件质量保证（QA）",
        text:
          "APJ立足于近20年极具竞争力的软件和信息技术服务基础，建立了专业的软件研发和质量保证流程，并形成了具有APJ特点的专业化管理方法论，同时拥有完善的知识产权保护以及信息安全保护机制，能快速响应客户需求，为客户降低成本、提高效率、控制风险，带来更高效、更有价值的服务体验。",
      },
      qcDesc: {
        special: true,
        icon: require("@/assets/site/service-QC.png"),
        title: "全生命周期测试（QC）",
        text:
          "APJ基于软件开发生命周期的不同阶段，提供系统化的测试，结合多年的测试服务经验研发出具有自主知识产权的自动化测试平台解决方案。在软件开发的每一个阶段，测试团队都以客户的需求为中心，及时发现问题并解决问题，最大程度规避风险，确保软件的质量得到保障。",
      },
      safe: {
        special: true,
        icon: require("@/assets/site/service-info-safe.png"),
        title: "知识产权与信息安全",
        items: [
          {
            icon: require("@/assets/site/service-protect.png"),
            title: "知识产权保护",
            desc:
              "APJ注重知识产权的保护，以客户的要求为基点，建立完善的知识产权保护员工行为规范，19年来无知识产权事故。",
            texts: [
              "健全的知识产权保护制度和管理体制，覆盖员工从上岗到离岗全过程",
              "所有ODC开发的软件可交付成果IP权利均属于客户",
              "严格遵守客户的安全性和IP保护要求",
            ],
          },
          {
            icon: require("@/assets/site/service-ISO27001.png"),
            img: require("@/assets/site/service-info-safe.png"),
            title: "信息安全保护",
            desc:
              "APJ有严格的安保体系，从物理环境、访问控制、数据网络安全、漏洞防护与系统安全等方面系统地对数据安全建立强有力的保障；并且根据ISO27001要求，制定RTO&RPO要求以确保核心业务的连续性，同时按照备份策略对核心数据进行备份和保护。",
            texts: [
              "使用企业级防火墙，电脑配备防病毒系统，安装入侵防御系统",
              "独立的专属封闭的办公区域，使用客户专线，对访问控制和监控",
              "制定应急计划RTO&RPO要求，确保核心业务的连续性",
              "根据IS027001要求的备份策略，对核心数据进行备份和保护"
            ],
          },
        ],
      },
      techInfo: [
        {
          icon: require("@/assets/site/service-tech.png"),
          name: "交付能力",
          tech: [
            "大数据",
            "云计算",
            "人工智能",
            "物联网",
            "网络信息安全",
            "应用开发",
            "...",
          ],
        },
        {
          icon: require("@/assets/images/service/icon/jiaofumoshi.svg"),
          name: "交付模式",
          tech: ["在岸", "离岸", "驻场"],
        },
        {
          icon: require("@/assets/images/service/icon/hangyejingyan.svg"),
          name: "行业经验",
          tech: [
            "金融行业",
            "生产制造",
            "石油化工",
            "轨道交通",
            "公共事业",
            "互联网教育",
            "...",
          ],
        },
      ],
      serviceTypes: [
        {
          icon: "iconzixun",
          title: "行业信息化咨询",
          text:
            "基于深厚的技术底蕴、深刻的业务理解及敏锐的互联网嗅觉，协助企业梳理信息化背景下的流程设计及管理目标，打造互联网+企业新业态，为企业的自我完善及持续创新注入活力。",
        },

        {
          icon: "iconruanjian-",
          title: "定制化软件研发",
          text:
            "拥有强大的技术研发团队及驾驭多种应用技术的研发实力，立足于企业的业务生产实际，放眼企业的信息化目标，助力企业研发符合自身业务目标及商业价值的定制化软件，提高企业的信息化水平，增强企业的核心竞争力。",
        },
        {
          icon: "iconxitong",
          title: "系统化技术支持",
          text:
            "根据客户需求，结合计算机技术，软硬件工程师为客户提供先进、高效、稳定、开放、安全的技术支持，助客户完成系统建设、系统迁移、系统优化、系统整合、业务实现、1T系统运营实施及软硬件测试服务，实现系统协同工作和客户成本最优化。",
        },
        {
          icon: "iconceshi",
          title: "第三方软件测试",
          text:
            "拥有自主知识产权的软件自动化测试平台及测试团队,为客户提供第三方软件评测，软件验收测试、软件性能测试、自动化测试、第三方安全渗透测试，测试报告评审，AP验收测试、H5验收测试及软件测试人员外派等第三方测试服务。",
        },
        {
          icon: "iconwaibaoguanli",
          title: "软件服务外包（ITO）",
          text:
            "根据客户需求建立离岸开发中心（ODC）或在岸开发。APJ为客户提供专属封闭办公区域的ODC，或在客户指定的开发地点，建立稳定的开发团队，按照客户安全和保密标准制定一套完整的建立开发的整套质量体系规范，帮助客户IT团队实现总体的目标和要求。",
        },
        {
          icon: "iconkaifarenyuan",
          title: "专业IT人才服务",
          text:
            "根据客户项目具体人员需求，将IT开发团队或个人外派到客户现场进行驻场软件开发，帮助客户按时按质完成项目，解决客户IT人才需求。APJ在IT开发团队的招聘、管理、培训和团队稳定性建设上有成熟的经验，给客户提供专业化的IT人才外包服务。",
        },
      ],
      // industryList: [
      //   {
      //     name: "生产制造",
      //     icon: "iconshengchanzhizao",
      //     title: "生产制造业",
      //     desc:
      //       "结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造”等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。",
      //     img: require("@/assets/site/industry_manufacturing.jpg"),
      //     link: [
      //       {
      //         text: "企业进销存管理系统",
      //         link: "",
      //       },
      //       {
      //         text: "标准仓储管理系统",
      //         link: "",
      //       },
      //       {
      //         text: "制造执行管理系统",
      //         link: "",
      //       },
      //       {
      //         text: "企业供应链管理系统",
      //         link: "",
      //       },
      //     ],
      //   },
      //   {
      //     name: "教育行业",
      //     icon: "iconjiaoyu1",
      //     title: "教育行业",
      //     desc:
      //       '结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造"等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。',
      //     img: require("@/assets/site/industry_education.jpg"),
      //   },
      //   {
      //     name: "医疗健康",
      //     icon: "iconyiliaohangye",
      //     title: "医疗健康",
      //     desc:
      //       '结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造"等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。',
      //     img: require("@/assets/site/industry_health.jpg"),
      //   },
      //   {
      //     name: "轨道交通",
      //     icon: "iconguidaojiaotong",
      //     title: "轨道交通",
      //     desc:
      //       '结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造"等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。',
      //     img: require("@/assets/site/industry_retail.jpg"),
      //   },
      //   {
      //     name: "石油化工",
      //     icon: "iconshiyouhuagong",
      //     title: "石油化工",
      //     desc:
      //       '结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造"等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。',
      //     img: require("@/assets/site/industry_petrochemical.jpg"),
      //   },
      //   {
      //     name: "金融行业",
      //     icon: "iconjinronghangye",
      //     title: "金融行业",
      //     desc:
      //       '结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造"等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。',
      //     img: require("@/assets/site/industry_finance.jpg"),
      //   },
      //   {
      //     name: "公共事业",
      //     icon: "icongonggongshiye",
      //     title: "公共事业",
      //     desc:
      //       '结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造"等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。',
      //     img: require("@/assets/site/industry_common.jpg"),
      //   },
      //   {
      //     name: "零售业",
      //     icon: "iconlingshouye",
      //     title: "零售业",
      //     desc:
      //       '结合物联网、互联网、云计算、大数据等相关信息技术，以“智能制造"等多种解决方案帮助客户转型升级，以更加积极主动的姿态融入全球贸易体系，积极践行与制造业企业开放与合作，积极参与全球范围内资源配置，赋能制造业企业智能化、数字化转型。',
      //     img: require("@/assets/site/industry_manufacturing.jpg"),
      //   },
      // ],
      // technology: [
      //   "loT技术",
      //   "RPA",
      //   "云计算",
      //   "人工智能",
      //   "大数据",
      //   "工业互联网",
      //   "PDM",
      //   "移动支付",
      //   "管理数字化",
      //   "SaaS",
      //   "连接型CRM",
      //   "物流数字化",
      //   "智能工单",
      //   "小程序",
      //   "线上商店",
      //   "APP",
      //   "跨境电商平台",
      //   "智能配送",
      // ],
    };
  },
  mounted() {
    this.show = true;
    // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
    globalEvent.$emit("changeHeaderTransparent", {
      isTransparent: true,
      isNoShadow: false,
    });
    globalEvent.$emit("changeMenu", 2);
    setTimeout(()=>{
      this.loadScroll();
      this.loadTop();
      window.scrollTo(1, 0);
    },500)
  },
  destroyed() {
    this.show = false;
  },
  methods: {
    loadScroll() {
      scrollTop((res) => {
        for (const key in this.offsetTop) {
          if (!this.show_obj[key] && res.scrollH >= this.offsetTop[key]) {
            this.show_obj[key] = true;
          }
        }
      });
    },
    loadTop() {
      for (const key in this.offsetTop) {
        const client_height = document.documentElement.clientHeight;
        const height = this.$refs[key].offsetHeight / 2;
        this.offsetTop[key] =
          this.$refs[key].offsetTop - client_height + height;
      }
    },
  },
  computed: {
    currentIndustry() {
      return this.industryList[this.indTabIndex];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";
.page-title {
  font-size: 30px;
  font-weight: bold;
}
div {
  width: 100%;
}
.setion {
  display: flex;
  flex-direction: column;
  padding: 40px 0;

  .desc {
    .text {
      margin-top: 20px;
    }
  }

  .list {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 30px);
    margin-left: -15px;
    margin-right: -15px;
  }
}
.service-list {
  // display: flex;
  // flex-direction: column;
  // padding: 0 0 50px;

  // .desc {
  //   .text {
  //     margin-top: 20px;
  //   }
  // }

  // .list {
  //   margin-top: 40px;
  //   display: flex;
  //   flex-wrap: wrap;
  //   width: calc(100% + 30px);
  //   margin-left: -15px;
  //   margin-right: -15px;
  // }

  .wrapper {
    padding: 15px;
    width: 33.3%;

    .item {
      border: 1px solid #e5e5e5;
      text-align: left;
      padding: 60px;
      display: flex;
      // min-height: 320px;
      height: 100%;

      .iconfont {
        color: $color-text-primary;
        font-size: 50px;
        margin-right: 15px;
        line-height: 0.8em;
      }

      .info {
        .title {
          line-height: 1em;
          padding-bottom: 15px;
          font-size: 20px;
          font-weight: bold;
        }
        .text {
          height: auto;
          font-size: 14px;
          line-height: 2em;
        }
      }
      &:hover {
        border-top: 6px solid $color-text-primary;
      }
    }

    &.special {
      .item {
        border: 0px;
        padding-left: 0;

        .info {
          .title {
            padding-bottom: 15px;
            font-size: 24px;
          }
        }
      }
    }
  }
}

.service-type {
  background-color: #f5f5f5;
  .wrapper {
    padding: 15px;
    width: 33.3%;

    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .el-image {
        width: 40px;
        height: 40px;
      }

      .name {
        background-color: $color-bg-primary;
        color: $color-text-white;
        padding: 0 50px;
        border-radius: 2em;
        height: 2em;
        margin-top: 24px;
        margin-bottom: -1em;
        z-index: 2;
      }

      .tech {
        width: 100%;
        height: 280px;
        padding: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: $color-bg-white;
        border-radius: 3px;
        font-size: 16px;
        line-height: 2em;
      }
    }
  }
  .tech-diagram {
    padding-top: 20px;
    display: flex;
    flex-direction: column;

    .diagram-row {
      display: flex;
      flex-direction: row;
      align-items: center;

      .title-box {
        width: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        i {
          color: $color-text-primary;
          font-size: 36px;
          padding: 10px;
        }
        span {
          font-weight: bold;
        }
      }
      .content-box {
        margin: 10px 0;
        padding: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        background-color: $color-bg-white;
        border-radius: 10px;
        .industry-box {
          display: flex;
          flex-direction: column;
          i {
            color: $color-text-primary;
            font-size: 32px;
            padding: 10px;
          }
          span {
            font-weight: bold;
          }
        }
        .techType-box {
          padding: 10px;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          div {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            white-space: nowrap;
          }
          span {
            font-weight: bold;
          }
        }
        .mode-box {
          display: flex;
          flex-direction: column;
          text-align: left;
          padding-right: 30px;

          .mode-btn {
            padding-left: 5px;
            margin-bottom: 10px;
            line-height: 16px;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            border-left: 2px solid $color-border-primary;
            // background-color: $color-bg-primary;
            // color: $color-text-white;
            // border-radius: 6px;
            font-weight: bold;
          }
          span {
            padding-right: 10px;
          }
        }
      }
    }
  }
}

.quality-assurance {
  .setion {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-image {
    margin: 40px 0;
    // width: 716px;
    // height: 335px;
    justify-content: center;
  }
}

.safe {
  .setion {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-image {
    margin: 20px 0;
    justify-content: center;
  }
}

.items {
  display: flex;
  flex-direction: column;
  .item {
    margin-top: 30px;
    padding: 20px;
    border: 1px solid $color-border-grey;
    display: flex;
    flex-direction: column;
    .content {
      padding: 20px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      text-align: left;
      .desc-content {
        padding: 20px 30px 20px 50px;
        .title {
          font-size: 28px;
          font-weight: bold;
          line-height: 1.5em;
        }
        ul {
          margin: 0;
        }
        ul.texts {
          padding: 20px 20px 0;
        }
        ul.texts li {
          color: $color-text-primary;
        }
        ul.texts li span {
          color: #333;
        }
      }
      .icon {
        max-width: 160px;
      }
    }
    .img {
      margin-top: 20px;
      margin-bottom: 0;
      width: 100%;
    }
  }
}

@media screen and (max-width: 1680px) and (min-width: 1440px) {
  .service-list {
    .wrapper {
      .item {
        text-align: left;
        padding: 40px;
        display: flex;
      }
    }
  }
}

@media screen and (max-width: 1439px) and (min-width: 1280px) {
  .service-list {
    .wrapper {
      .item {
        flex-direction: column;
        text-align: left;
        padding: 40px 30px 40px;
        display: flex;

        .iconfont {
          padding-bottom: 30px;
        }
      }
    }
  }
}

@media screen and (max-width: 1279px) {
  .service-list {
    .wrapper {
      .item {
        flex-direction: column;
        text-align: left;
        padding: 40px 30px 40px;
        display: flex;

        .iconfont {
          padding-bottom: 30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/index.vue